import { computed, ref } from "vue";

const state = ref({
  initialized: false,
  active: false,
  info: {
    host: undefined,
    platform: undefined,
  },
} as {
  initialized: boolean;
  active: boolean;
  info: {
    host?: Office.HostType;
    platform?: Office.PlatformType;
  };
});

async function init() {
  const info = await Office.onReady();
  if (!info.host) {
    state.value.active = false;
  } else {
    state.value.info = info;
    state.value.active = true;
  }
  state.value.initialized = true;
}

const isActive = computed(() => state.value.active);
const isInitialized = computed(() => state.value.initialized);
const getInfo = computed(() => state.value.info);

export { init, isActive, isInitialized, getInfo };
